import { useEffect, useState } from 'react';
import useTutorialStore from '../../stores/tutorialStore';
import fetchWithTenant from '../../utils/fetchWithTenant';

const AUTO_DISMISS_MS = 10000;

const TutorialPrompt = ({ module, moduleName, steps, onClose }) => {
  const startTutorial = useTutorialStore((s) => s.startTutorial);
  const isActive = useTutorialStore((s) => s.isActive);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => {
      setVisible(false);
      if (onClose) onClose('timeout');
    }, AUTO_DISMISS_MS);
    return () => clearTimeout(t);
  }, [onClose]);

  if (!visible || isActive) return null;

  const handleYes = () => {
    setVisible(false);
    startTutorial(module, steps);
    if (onClose) onClose('accepted');
  };

  const handleNo = async () => {
    setVisible(false);
    try {
      await fetchWithTenant('/api/tutorials/progress', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ module, dismissed: true }),
      });
    } catch (err) {
      console.error('[TutorialPrompt] dismiss failed', err);
    }
    if (onClose) onClose('dismissed');
  };

  return (
    <div className="tutorial-prompt" role="dialog" aria-live="polite">
      <div className="tutorial-prompt-body">
        <div className="tutorial-prompt-title">Quick tour?</div>
        <div className="tutorial-prompt-message">
          Would you like a quick tour of {moduleName}?
        </div>
      </div>
      <div className="tutorial-prompt-actions">
        <button type="button" className="tutorial-btn tutorial-btn-skip" onClick={handleNo}>
          No thanks
        </button>
        <button type="button" className="tutorial-btn tutorial-btn-next" onClick={handleYes}>
          Yes, show me
        </button>
      </div>
    </div>
  );
};

export default TutorialPrompt;
